import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router'
import HomePage from '@portal/HomePage'
import LoginPage from '@portal/LoginPage'
import VaktChecklistPage from '@portal/VaktChecklistPage'

const rootRoute = createRootRoute()

const homeRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  component: () => <HomePage />,
})

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: () => <LoginPage />,
})

const vaktChecklistRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vakt/checklist',
  component: () => <VaktChecklistPage />,
})

const routeTree = rootRoute.addChildren([
  homeRoute,
  loginRoute,
  vaktChecklistRoute,
])

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  scrollRestoration: true,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
